module.exports = __webpack_public_path__ + "static/media/BrandMt.5dd92a18.svg";